// @unocss-include
import { DISCORD, LINKEDIN, X, REDDIT, YOUTUBE, INSTAGRAM } from '~/lib/urls';

type SocialLink = {
  href: string;
  icon: string;
  name: string;
  displayInHeader: boolean;
};

export const socialLinks: SocialLink[] = [
  {
    href: DISCORD,
    icon: 'i-bolt:logos-discord?mask',
    name: 'Discord',
    displayInHeader: true,
  },
  {
    href: LINKEDIN,
    icon: 'i-bolt:logos-linkedin?mask',
    name: 'LinkedIn',
    displayInHeader: true,
  },
  {
    href: YOUTUBE,
    icon: 'i-bolt:logos-youtube?mask',
    name: 'YouTube',
    displayInHeader: false,
  },
  {
    href: X,
    icon: 'i-bolt:logos-x?mask',
    name: 'Twitter/X',
    displayInHeader: true,
  },
  {
    href: INSTAGRAM,
    icon: 'i-bolt:logos-instagram?mask',
    name: 'Instagram',
    displayInHeader: false,
  },
  {
    href: REDDIT,
    icon: 'i-bolt:logos-reddit?mask',
    name: 'Reddit',
    displayInHeader: true,
  },
];
